// @flow
import React from 'react';
import BoardMergeWarning from 'app/common/react/components/BoardEdit/BoardMergeWarning';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import type { DesktopProfileBoard } from 'app/packages/pinterest-flow-types/board';
import { Box, Button } from 'gestalt';

type Props = {|
  onConfirm: (source: DesktopProfileBoard, target: DesktopProfileBoard) => void,
  onHide: () => void,
  sourceBoard: DesktopProfileBoard,
  targetBoard: DesktopProfileBoard,
|};

export default function ConfirmMergeModal({ onConfirm, onHide, sourceBoard, targetBoard }: Props) {
  return (
    <Modal
      accessibilityCloseLabel={i18n._('Close', 'close button')}
      accessibilityModalLabel={i18n._(
        'Confirm Board Merge',
        'accessibility label for board merging confirmation modal',
      )}
      onDismiss={onHide}
      heading={i18n._(
        'Move Pins and delete board?',
        'Modal heading for board merging confirmation modal',
      )}
      role="dialog"
      size="md"
      footer={
        <Box
          alignItems="center"
          display="flex"
          justifyContent="end"
          marginLeft={-2}
          marginRight={-2}
        >
          <Box paddingX={2}>
            <Button
              inline
              text={i18n._('Cancel', 'Cancel button in board merging confirmation modal')}
              onClick={onHide}
            />
          </Box>
          <Box paddingX={2}>
            <Button
              inline
              color="red"
              text={i18n._(
                'Move Pins and delete board',
                'Confirm button in board merging confirmation modal',
              )}
              onClick={() => onConfirm(sourceBoard, targetBoard)}
            />
          </Box>
        </Box>
      }
    >
      <Box padding={4}>
        <BoardMergeWarning sourceBoard={sourceBoard} targetBoard={targetBoard} />
      </Box>
    </Modal>
  );
}
